import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as ComponentWidgets from '../widgets';
import * as ContainerWidgets from '../../containers/widgets';

const Components = {
    component: {
        ...ComponentWidgets,
    },
    container: {
        ...ContainerWidgets,
    },
};

const HeaderComponentWrapper = ({
    props: componentProps = {},
    componentClass = '',
    classType = 'component',
    actions = [],
    selector = () => {},
}) => {
    const createdContainerRef = useRef(null);

    if (!createdContainerRef.current) {
        const mapStateToProps = state => {
            const stateProps = selector ? selector(state) : {};
            return {
                ...componentProps,
                ...stateProps,
            };
        };

        const mapDispatchToProps = dispatch => {
            return actions.reduce((total, current) => {
                total[current.actionName] = (...args) => {
                    if (!current.action) {
                        return;
                    }
                    let actionList = current.action;
                    if (typeof current.action === 'function') {
                        actionList = [current.action];
                    }
                    for (const actionCreator of actionList) {
                        const action = actionCreator(...args);
                        if (!action) {
                            return;
                        }
                        dispatch(action);
                    }
                };
                return total;
            }, {});
        };

        createdContainerRef.current = connect(
            mapStateToProps,
            mapDispatchToProps
        )(Components[classType][componentClass]);
    }

    const CreatedContainer = createdContainerRef.current;
    return <CreatedContainer />;
};

HeaderComponentWrapper.propTypes = {
    props: PropTypes.objectOf(PropTypes.any),
    componentClass: PropTypes.string,
    classType: PropTypes.string,
    actions: PropTypes.arrayOf(PropTypes.object),
    selector: PropTypes.func,
};

export default HeaderComponentWrapper;
